import { assetUrl } from '../utils/assets';

export type DiceOutcome = 'success' | 'failure' | 'auto_success' | 'auto_failure';

const POOLS: Record<DiceOutcome, string[]> = {
  auto_success: ['percy_smug_blackmail', 'percy_content'],
  success: ['percy_smug_blackmail', 'percy_mischievous', 'percy_content'],
  auto_failure: ['tutorial_16', 'percy_dawning_realization', 'percy_yowling_closeup'],
  failure: [
    'percy_shocked_face',
    'percy_tail_puff_alarm',
    'percy_overhead_surrender',
    'percy_worried',
    'percy_dawning_realization',
    'percy_yowling_closeup',
    'percy_argument_backfire',
    'percy_secret_agent_face',
  ],
};

export function pickPercyReaction(outcome: DiceOutcome): string {
  const pool = POOLS[outcome];
  const name = pool[Math.floor(Math.random() * pool.length)];
  return assetUrl(`/assets/illustrations/${name}.png`);
}
